<template>
    <div class="h-full">
        <VueSlickCarousel v-bind="settings" class="h-full rounded-3xl">
            <div class="px-1 h-full" v-for="course in free_courses">
                <a :href="'/trainings/register?i=' + course.registration_hash" class="free-course-tile" v-bind:style="{ backgroundImage: 'url('+ course.training_image +')' }">
                    <div>
                        <span class="text-sm my-2 headline-spacing-1 uppercase" v-text="$options.filters['lang']('copy.free_course')"></span>
                    </div>
                    <h2 class="font-bold leading-tight roboto-slab mb-4">
                        <span v-text="course.title"></span>
                    </h2>
                    <div v-if="course.note" class="free-course-description">
                        <span>{{ course.note | stripHTML }}</span>
                    </div>
                </a>
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'Freecoursecarousel',
    props: [
        'free_courses'
    ],
    components: { VueSlickCarousel },
    data() {
        return {
            settings: {
                "focusOnSelect": true,
                "infinite": true,
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "touchThreshold": 5,
                "arrows": false,
                "dots": true,
                "autoplay": true,
                "speed": 2000,
                "autoplaySpeed": 10000,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            "arrows": false,
                            "edgeFriction": 0.35,
                            "infinite": true,
                            "autoplay": true,
                            "speed": 2000,
                            "autoplaySpeed": 10000,
                        }
                    }
                ]
            },
        }
    },
}
</script>

<style scoped>

</style>
